/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

export type ListUsersStatus = (typeof ListUsersStatus)[keyof typeof ListUsersStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListUsersStatus = {
  active: 'active',
  inactive: 'inactive',
} as const;
